import { List, Typography } from "@material-ui/core";
import DeleteIcon from "@mui/icons-material/Delete";
import { AddCircleOutline } from "@material-ui/icons";
import { AppDialog } from "./AppDialog";
import { AppSpinner } from "./AppSpinner";
import { SimpleAutoComplete } from "./SimpleAutoComplete";
import Project from "../models/Project";
import { EnsolversOpsUser } from "../models/EnsolversOpsUser";
import ProjectService from "../services/ProjectService";
import NotificationService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { Dispatch, SetStateAction } from "react";
import AutoCompleteUIDTO from "../dto/AutoCompleteUIDTO";
import UserService from "../services/UserService";
import Grid from "@mui/material/Grid/Grid";
import ListItem from "@mui/material/ListItem/ListItem";
import IconButton from "@mui/material/IconButton/IconButton";

interface Props {
  editProjectManager: Project | undefined;
  handleCloseManagerModal: () => void;
  managerList: EnsolversOpsUser[] | undefined;
  setManagerList: Dispatch<SetStateAction<EnsolversOpsUser[] | undefined>>;
  setUpdate: Dispatch<SetStateAction<number | undefined>>;
  setSearchManager: Dispatch<SetStateAction<AutoCompleteUIDTO | undefined>>;
  searchManager: AutoCompleteUIDTO | undefined;
  userNames: AutoCompleteUIDTO[];
}

export const ModalAddRemovePM = ({
  editProjectManager,
  handleCloseManagerModal,
  managerList,
  setManagerList,
  setUpdate,
  setSearchManager,
  searchManager,
  userNames,
}: Props) => {
  const assignProjectManagerToProject = () => {
    if (!searchManager) {
      NotificationService.error("You should first select a PM from the list.");
      return;
    }

    UserService.getByExternalId(searchManager.externalId).then((response) => {
      if (editProjectManager?.externalId && managerList) {
        ProjectService.addManagerToProject(editProjectManager.externalId, searchManager.externalId)
          .then(() => {
            setManagerList([...managerList, response.getContentOrThrowError()]);
            setUpdate(Date.now());
          })
          .catch((e) => NotificationService.error(e.response.data.message));
      }
    });
  };
  return (
    <AppDialog
      open={!!editProjectManager}
      onClose={handleCloseManagerModal}
      title="Assigned Managers"
      hideCancel
      content={
        <>
          <Grid container display="flex" alignItems="center" justifyItems="center">
            <Grid item xs={12} sx={{ marginBottom: "2em" }}>
              {managerList === undefined ? (
                <AppSpinner />
              ) : managerList.length === 0 ? (
                <Typography>There is no assigned managers.</Typography>
              ) : (
                <List>
                  {managerList.map((item, itemIndex) => (
                    <ListItem
                      key={itemIndex}
                      secondaryAction={
                        <IconButton
                          edge="end"
                          aria-label="delete"
                          onClick={() => {
                            ProjectService.removeManagerFromProject(
                              editProjectManager?.externalId || "",
                              managerList[itemIndex]?.externalId || ""
                            )
                              .then(() => {
                                setManagerList(managerList.filter((item, index) => index !== itemIndex));
                                setUpdate(Date.now());
                              })
                              .catch((e) => NotificationService.error(e.response.data.message));
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      }
                    >{`• ${item.firstName} ${item.lastName}`}</ListItem>
                  ))}
                </List>
              )}
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={10}>
              <SimpleAutoComplete
                label="Add a new manager"
                items={userNames}
                value={searchManager!}
                onChange={(newValue) => setSearchManager(newValue)}
                disablePortal={false}
              />
            </Grid>
            <Grid item xs={2}>
              <IconButton
                onClick={assignProjectManagerToProject}
                size="large"
                sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}
              >
                <AddCircleOutline />
              </IconButton>
            </Grid>
          </Grid>
        </>
      }
      buttons={[{ label: "Close", onClick: () => handleCloseManagerModal() }]}
    />
  );
};
